<rask-icon
    class="append-icon"
    [ngClass]="{ 'success': isValid, 'fail': !isValid}"
    icon="fas fa-check-circle"
    [text]="text">
</rask-icon>
